import { InteractiveContainer } from "@jugl-web/ui-components/cross-platform";
import { FC, useState } from "react";
import { Lottie } from "@jugl-web/utils/utils/Lottie";
import { useTranslations } from "@jugl-web/utils";
import { useNavigation } from "@web-src/modules/navigation/hooks/useNavigation";
import { EntityLimitReachedAlert } from "@web-src/modules/auth/pages/SignUpNewWorkspaceSetup/components/EntityLimitReachedAlert/EntityLimitReachedAlert";
import animationIconData from "./assets/animation-icon.json";
import { ReactComponent as AddIcon } from "./assets/add-icon.svg";

export const CreateNewEntityButton: FC<{
  isLimitReached?: boolean;
  onCreateClick?: () => void;
}> = ({ isLimitReached = false, onCreateClick }) => {
  const { navigateToPage } = useNavigation();
  const { t } = useTranslations();

  const [isEntityLimitReachedAlertOpen, setIsEntityLimitReachedAlertOpen] =
    useState(false);
  const handleAddOrganizationClick = async () => {
    if (isLimitReached) {
      setIsEntityLimitReachedAlertOpen(true);
      return;
    }
    if (onCreateClick) {
      onCreateClick();
      return;
    }
    navigateToPage("authNewWorkspace", {
      flow: "inapp",
    });
  };

  return (
    <>
      <EntityLimitReachedAlert
        isOpen={isEntityLimitReachedAlertOpen}
        onClose={() => setIsEntityLimitReachedAlertOpen(false)}
      />
      <InteractiveContainer
        className="flex h-[73px] items-center overflow-hidden rounded-2xl"
        onClick={handleAddOrganizationClick}
        as="div"
        style={{
          background: "linear-gradient(270deg, #DAEFFB 0.03%, #F6F3FF 99.98%)",
        }}
      >
        <div className="relative -top-[8px]">
          <Lottie
            options={{ animationData: animationIconData }}
            width={84}
            height={84}
          />
        </div>
        <div className="flex-1">
          <div className="font-secondary text-sm leading-4 font-medium text-dark">
            {t({
              id: "entities-page.create-new-workspace",
              defaultMessage: "Create New Workspace",
            })}
          </div>
          <div className="font-primary text-xs leading-2 text-[#707577]">
            {t({
              id: "entities-page.tap-to-create",
              defaultMessage: "Tap to create",
            })}
          </div>
        </div>
        <div className="mr-[18px] flex h-[28px] w-[28px] items-center justify-center rounded-[6px] bg-primary-500">
          <AddIcon />
        </div>
      </InteractiveContainer>
    </>
  );
};
